import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEventMutationVariables = Types.Exact<{
  input: Types.CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', id: string, external_zoho_id?: string | null, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, is_authorized_signer_necessary: boolean, currency: string, entity: Types.LegalEntity, type: Types.EventType, is_deleted: boolean, event_participants?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string }> | null }> | null, allowed_container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null }> } };


export const CreateEventDocument = gql`
    mutation createEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    id
    external_zoho_id
    name
    description
    image_url
    start_date
    end_date
    is_authorized_signer_necessary
    currency
    entity
    type
    is_deleted
    event_participants {
      id
      name
      item_locations {
        id
        name
      }
    }
    allowed_container_types {
      id
      name
      image
    }
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;